
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div id=\"main-content\" class=\"card\">\n  <header id=\"legal-header\">\n    <h1 id=\"fxa-legal-header\">{{#t}}Legal{{/t}}</h1>\n  </header>\n\n  <section class=\"links\">\n    <a href=\"/legal/terms\" class=\"left\">{{#t}}Terms of Service{{/t}}</a>\n    <a href=\"/legal/privacy\" class=\"right\">{{#t}}Privacy Notice{{/t}}</a>\n  </section>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  


//////////////////
// WEBPACK FOOTER
// ./templates/legal.mustache
// module id = 262
// module chunks = app